/* eslint-disable indent */
import { useState } from "react";
import { ConfirmationStatus, DIALOG_DEFAULTS } from "../constants";

export const useDialogState = (initialDialogData) => {
    const [state, setState] = useState(() => {
        return initialDialogData
            ? {
                  dialogData: {
                      ...DIALOG_DEFAULTS,
                      ...initialDialogData,
                  },
                  status: ConfirmationStatus.READY,
              }
            : {
                  dialogData: {
                      choiceName: "NONE",
                      options: [],
                  },
                  status: ConfirmationStatus.CLOSED,
              };
    });

    return [state, setState];
};
